import { Component, OnInit, Input, HostListener } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'auth-header',
    templateUrl: './auth-header.component.html'
})
export class AuthHeaderComponent implements OnInit {


    @Input('headerText') headerText: string = "";
    @Input('isShowBackIcon') isShowBackIcon: string = "";

    // Modified by Nishant Agrawal 01 Feb 2019. Story #1863
    @HostListener('document:click', ['$event']) clickedOutside($event) {
        this.hideMenuBar();
    }

    isMenuShow: boolean = false;
    username: string;

    constructor(
        private router: Router,
    ) { }

    ngOnInit() {
        let user = localStorage.getItem('username');
        if (user != null) {
            this.username = user;
        }
    }

    showMenuBar($event: Event) {
        $event.stopPropagation(); 
        this.isMenuShow = true;
    }

    hideMenuBar() {
        this.isMenuShow = false;
    }

    logout() {
        window.localStorage.removeItem('token');
        window.localStorage.removeItem('username');
        window.localStorage.removeItem('bookingJourneySessionId');
        this.router.navigate(['/auth/login']);
    }

    // Modified by Nishant Agrawal 01 Feb 2019. Story #1863
    clickedMenuInside($event: Event) {
        $event.stopPropagation();  // <- that will stop propagation on lower layers
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/layout/auth-header/auth-header.component.ts